module.exports = __webpack_public_path__ + "img/main.f9b55b3f.png";